import React from "react";
import Review from "../../components/CustomerReviews/Review";
import Rater from "react-rater";
import "react-rater/lib/react-rater.css";
import { connect } from "react-redux";
import "./CustomerReviews.css";
import Show from "../../functional/Show";

type Props = {
  ratingNumber: ?number,
  customerReviews: Array<any>
};

const CustomerReviews = ({ customerReviews, ratingNumber }: Props) => {
  let reviews = [];

  try {
    reviews = JSON.parse(customerReviews);
  } catch (e) {
    console.error(
      `Error while parsing reviews: ${customerReviews}, check admin panel for product.`
    );
  }

  return (
    <Show when={reviews.length}>
      <div id="reviews">
        <div className="reviews-header">
          <h2>Customer Reviews</h2>
          <Rater total={5} rating={parseFloat(ratingNumber)} interactive={false} />
          <span className="rating">{parseFloat(ratingNumber)} out of 5 stars</span>
        </div>
        {reviews.map((review, i) => (
          <Review key={i} review={review}></Review>
        ))}
      </div>
    </Show>
  );
};

const mapStateToProps = (state: Object) => ({
  ratingNumber: state.rawProduct.customer_review_stars,
  customerReviews: state.rawProduct.customer_reviews_section
});

export default connect(mapStateToProps)(CustomerReviews);



// WEBPACK FOOTER //
// ./src/components/CustomerReviews/index.js